import moment, { Moment } from 'moment';

export function formatDate(year: number, month?: number, day?: number): string {
  let date = moment({ year: year, month: month !== undefined ? month - 1 : undefined, day: day });

  if (month === undefined) {
    return date.format('YYYY');
  } else if (day === undefined) {
    return date.format('MMMM, YYYY');
  } else {
    return date.format('D MMMM, YYYY');
  }
}

export function getCurrentDate(): Moment {
  return moment();
}

/**
 * Format a timestamp to a human-readable date and time string
 * @param timestamp - Moment object or ISO string
 * @returns Formatted string like "January 15, 2024 3:45 PM"
 */
export function formatDateTime(timestamp: Moment | string | null | undefined): string {
  if (!timestamp) return '-';

  const momentDate = typeof timestamp === 'string' ? moment(timestamp) : timestamp;

  if (!momentDate || !momentDate.isValid()) return '-';

  return momentDate.format('MMMM D, YYYY h:mm A');
}

/**
 * Format a timestamp to a short date string
 * @param timestamp - Moment object or ISO string
 * @returns Formatted string like "Jan 15, 2024"
 */
export function formatDateShort(timestamp: Moment | string | null | undefined): string {
  if (!timestamp) return '-';

  const momentDate = typeof timestamp === 'string' ? moment(timestamp) : timestamp;

  if (!momentDate || !momentDate.isValid()) return '-';

  return momentDate.format('MMM D, YYYY');
}